import RegistrationForm from '../Components/RegistrationForm';
import ProConversionForm from '../Components/ProConversionForm';
import EnterpriseConversionForm from '../Components/EnterpriseConversionForm';
import { IncreaseFreeTrialForm } from '../Components/IncreaseFreeTrialForm';
import { FreePropertyUpdateForm } from '../Components/FreePropertyUpdateForm';
import { InviteUsers } from '../Components/InviteUsers';
import CopyTransfer from '../Components/CopyTransfer';
import UpdateContract from '../Components/UpdateContract';
import DownloadUsageSummary from '../Components/DownloadUsageSummary';
import { ChangePassword } from '../Components/ChangePassword';
import { BlockUser } from '../Components/BlockUser';
import { SOPManagement } from '../Components/SOP';
import EnablePlatformAccess from '../Components/EnablePlatformAccess';
import RequestOnHold from '../Components/RequestOnHold';
import UserMFADisable from '../Components/UserMFADisable';
import { ProPricingConversion } from '../Components/ProPricingConversion';
import BeamModuleManagement from '../Components/BeamModuleManagement';
// import { EnterpriseToPro } from '../Components/EnterpriseToPro';

export const EMAIL_REGX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const CATEGORY_PRICING_TYPES = {
  FRESH: 'fresh',
  ADDENDUM: 'addendum'
};

export const COMPANY_ENUM = {
  USL: 1,
  GG: 2,
  REXEL: 3
};

export const FORM_COMPONENTS = {
  REGISTRATION_FORM: <RegistrationForm />,
  PRO_CONVERSION_FORM: <ProConversionForm />,
  ENTERPRISE_CONVERSION_FORM: <EnterpriseConversionForm showCategoryPricing totalUsers={0} />,
  INCREASE_FREE_TRIAL_FORM: <IncreaseFreeTrialForm />,
  FREE_PROPERTY_UPDATE_FORM: <FreePropertyUpdateForm />,
  USAGE_SUMMARY: <DownloadUsageSummary downloadBothUsage />,
  USAGE_SUMMARY_USL: <DownloadUsageSummary company={COMPANY_ENUM.USL} />,
  USAGE_SUMMARY_GG: <DownloadUsageSummary company={COMPANY_ENUM.GG} />,
  INVITE_USER: <InviteUsers />,
  COPY_TRANSFER: <CopyTransfer />,
  UPDATE_CONTRACT: <UpdateContract />,
  CHANGE_PASSWORD: <ChangePassword />,
  BLOCK_USER: <BlockUser />,
  // SOP_MANAGEMENT: <SOPManagement />
  // ENTERPRISE_TO_PRO: <EnterpriseToPro />,
  ENABLE_PLATFORM_ACCESS: <EnablePlatformAccess />,
  REQUEST_ON_HOLD: <RequestOnHold />,
  PRO_PRICING_CONVERSION: <ProPricingConversion />,
  BEAM_MODULE_MANAGEMENT: <BeamModuleManagement />
};

export const BEAM_FORM_COMPONENTS = {
  REGISTRATION_FORM: <RegistrationForm />,
  PRO_CONVERSION_FORM: <ProConversionForm />,
  ENTERPRISE_CONVERSION_FORM: <EnterpriseConversionForm showCategoryPricing totalUsers={10} />,
  INCREASE_FREE_TRIAL_FORM: <IncreaseFreeTrialForm />,
  FREE_PROPERTY_UPDATE_FORM: <FreePropertyUpdateForm />,
  USAGE_SUMMARY: <DownloadUsageSummary isBlueprintSummary />,
  USAGE_SUMMARY_REXEL: <DownloadUsageSummary company={COMPANY_ENUM.REXEL} />,
  INVITE_USER: <InviteUsers />,
  COPY_TRANSFER: <CopyTransfer />,
  UPDATE_CONTRACT: <UpdateContract />,
  CHANGE_PASSWORD: <ChangePassword />,
  BLOCK_USER: <BlockUser />,
  SOP_MANAGEMENT: <SOPManagement />,
  USER_MFA_DISABLE: <UserMFADisable />,
  BEAM_MODULE_MANAGEMENT: <BeamModuleManagement />
};

export const BEAM_FORM_LABELS = {
  REGISTRATION_FORM: 'User Registration (Free Trial)',
  PRO_CONVERSION_FORM: 'Pro Conversion (Credit Card)',
  ENTERPRISE_CONVERSION_FORM: 'Enterprise Conversion (New Contract Setup)',
  INCREASE_FREE_TRIAL_FORM: 'Increase Free Trial ',
  FREE_PROPERTY_UPDATE_FORM: 'Update Free Properties',
  USAGE_SUMMARY: 'Download Usage Summary',
  USAGE_SUMMARY_BPT: 'Download Usage Summary - Blueprint',
  USAGE_SUMMARY_REXEL: 'Download Usage Summary for Rexel',
  INVITE_USER: 'Invite User',
  COPY_TRANSFER: 'Copy transfer',
  UPDATE_CONTRACT: 'Update Enterprise Contract',
  CHANGE_PASSWORD: 'Change Password',
  BLOCK_USER: 'Block/Unblock User',
  SOP_MANAGEMENT: 'SOP Management',
  USER_MFA_DISABLE: 'User MFA Disable',
  BEAM_MODULE_MANAGEMENT: 'Configure Non-Takeoff Features'
};

export const FORM_LABELS = {
  REGISTRATION_FORM: 'User Registration (Free Trial)',
  PRO_CONVERSION_FORM: 'Pro Conversion (Credit Card)',
  ENTERPRISE_CONVERSION_FORM: 'Enterprise Conversion (New Contract Setup)',
  // ENTERPRISE_CONVERSION_FOR_BEAM_FORM: 'Enterprise Conversion for Beam',
  INCREASE_FREE_TRIAL_FORM: 'Increase Free Trial ',
  FREE_PROPERTY_UPDATE_FORM: 'Update Free Properties',
  USAGE_SUMMARY: 'Download Usage Summary',
  USAGE_SUMMARY_USL: 'Download Usage Summary for US Lawns',
  USAGE_SUMMARY_GG: 'Download Usage Summary for Ground Guys',
  INVITE_USER: 'Invite User',
  COPY_TRANSFER: 'Copy transfer',
  UPDATE_CONTRACT: 'Update Enterprise Contract',
  CHANGE_PASSWORD: 'Change Password',
  BLOCK_USER: 'Block/Unblock User',
  // SOP_MANAGEMENT: 'SOP Management'
  // ENTERPRISE_TO_PRO: 'Enterprise to Pro Conversion',
  ENABLE_PLATFORM_ACCESS: 'Enable Platform Access',
  REQUEST_ON_HOLD: 'Change Request Status',
  PRO_PRICING_CONVERSION: 'Pro Pricing Conversion',
  BEAM_MODULE_MANAGEMENT: 'Configure Non-Takeoff Features'
};

export const inputGroups = [
  {
    label: 'Property Type',
    field: null,
    placeholder: 'FP Left',
    extraClass: 'disabled',
    readOnly: true
  },
  { label: 'Automated Aerial', field: 'free_properties' },
  { label: 'Automated Blueprint', field: 'free_properties_blueprint' },
  { label: 'Manual Aerial', field: 'free_properties_manual' },
  { label: 'Manual Blueprint', field: 'free_properties_blueprint_manual' }
];

export const beamInputGroups = [
  {
    label: 'Property Type',
    field: null,
    placeholder: 'FP Left',
    extraClass: 'disabled',
    readOnly: true
  },
  { label: 'Automated Blueprint', field: 'free_properties_blueprint' },
  { label: 'Manual Blueprint', field: 'free_properties_blueprint_manual' }
];

export const COUNTRY_CODE = {
  USA: 'US',
  CANADA: 'CA',
  AUSTRALIA: 'AU',
  WORLD: 'WR'
};

export const COUNTRY = {
  [COUNTRY_CODE.USA]: 'United States',
  [COUNTRY_CODE.CANADA]: 'Canada',
  [COUNTRY_CODE.WORLD]: 'World',
  [COUNTRY_CODE.AUSTRALIA]: 'Australia'
};

export const CHECHBOX_FIELDS = [
  'apply_role_level_restriction',
  'ignore_concurrency_limit',
  'show_optional_feature',
  'restrict_custom_report_creation',
  'restrict_report_switching',
  'ignore_size_limit',
  'ignore_draft_limit',
  'ignore_marketing_mailer',
  'is_pilot'
];

export const CHECKBOX_FIELDS_BEAM_USER = [
  'apply_role_level_restriction',
  'ignore_concurrency_limit',
  'ignore_draft_limit',
  'ignore_marketing_mailer',
  'is_pilot'
];

// const Navigation Enum
export const Navigation = {
  0: '/',
  1: '/operations',
  2: '/company',
  3: '/enterprise-dashboard',
  // 4: '/validate-requests',
  4: '/coupon',
  5: '/promotional'
};

export const BeamNavigation = {
  0: '/',
  1: '/company',
  // 2: '/enterprise-dashboard',
  2: '/validate-requests',
  // 4: '/coupon',
  // 5: '/promotional',
  3: '/rosetta'
};

export const COMPANY_VERTICAL_ENUM = {
  FIELD_SERVICE: 1,
  ACE: 2,
  SPADE: 3
};

export const COMPANY_VERTICAL = {
  [COMPANY_VERTICAL_ENUM.FIELD_SERVICE]: 'Facility Services (FS)',
  [COMPANY_VERTICAL_ENUM.ACE]: 'Ace',
  [COMPANY_VERTICAL_ENUM.SPADE]: 'Spade'
};

export const ACCOUNT_SEGMENT_ENUM = {
  MID_MARKET: 1,
  LARGE_ENTERPRISE: 2
};

export const ACCOUNT_SEGMENT = {
  [ACCOUNT_SEGMENT_ENUM.MID_MARKET]: 'Mid-Market',
  [ACCOUNT_SEGMENT_ENUM.LARGE_ENTERPRISE]: 'Large Enterprise'
};

export const GROUP_INPUT_DATA = [
  {
    key: 'group-0',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Business Unit',
        valueKey: 'company_vertical',
        type: 'select',
        ariaLabel: 'business unit',
        options: COMPANY_VERTICAL,
        required: true
      },
      {
        label: 'Account Segment',
        valueKey: 'account_segment',
        type: 'select',
        ariaLabel: 'account segment',
        options: ACCOUNT_SEGMENT,
        required: true
      }
    ]
  },
  {
    key: 'group-csm-1',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Key Account Manager',
        valueKey: 'key_account_manager',
        type: 'text',
        ariaLabel: 'key account manager',
        placeholder: 'Comma separated emails',
        required: true
      }
    ]
  },
  {
    key: 'group-csm-2',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Onboarding Specialist',
        valueKey: 'onboarding_specialist',
        type: 'text',
        ariaLabel: 'onboarding specialist',
        placeholder: 'Comma separated emails (optional)'
      }
    ]
  },
  {
    key: 'group-1',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Max Size Limit',
        valueKey: 'max_size_limit',
        type: 'text',
        ariaLabel: 'max size limit',
        required: true
      },
      {
        label: 'Concurrency Aerial Value',
        valueKey: 'concurrency_value',
        type: 'text',
        ariaLabel: 'concurrency limit',
        required: true
      }
    ]
  },
  {
    key: 'group-2',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Min Size Limit',
        valueKey: 'min_measurement_size_unit',
        type: 'text',
        ariaLabel: 'min measurement size unit',
        required: true
      },
      {
        label: 'End Date',
        valueKey: 'end_date',
        type: 'date',
        ariaLabel: 'end date',
        min: '2023-01-01T00:00',
        max: '2040-12-31T23:59',
        required: true
      }
    ]
  },
  {
    key: 'group-3',
    className: 'input-group mb-3 ',
    showLabel: false,
    inputs: [
      {
        placeholder: 'Subdomain (optional)',
        valueKey: 'subdomain',
        type: 'text',
        ariaLabel: 'Subdomain'
      },
      {
        placeholder: 'Callback URL (optional)',
        valueKey: 'callback_url',
        type: 'text',
        ariaLabel: 'Callback URL'
      }
    ]
  },
  {
    key: 'group-4',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Concurrency Construction Value',
        valueKey: 'concurrency_value_construction',
        type: 'number',
        ariaLabel: 'concurrency value construction',
        min: 0,
        required: true
      }
    ]
  }
];

export const GROUP_INPUT_DATA_FOR_BEAM_USER = [
  {
    key: 'group-0',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Business Unit',
        valueKey: 'company_vertical',
        type: 'select',
        ariaLabel: 'business unit',
        options: COMPANY_VERTICAL,
        required: true
      },
      {
        label: 'Account Segment',
        valueKey: 'account_segment',
        type: 'select',
        ariaLabel: 'account segment',
        options: ACCOUNT_SEGMENT,
        required: true
      }
    ]
  },
  {
    key: 'group-csm-1',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Key Account Manager',
        valueKey: 'key_account_manager',
        type: 'text',
        ariaLabel: 'key account manager',
        placeholder: 'Comma separated emails',
        required: true
      }
    ]
  },
  {
    key: 'group-csm-2',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Onboarding Specialist',
        valueKey: 'onboarding_specialist',
        type: 'text',
        ariaLabel: 'onboarding specialist',
        placeholder: 'Comma separated emails (optional)'
      }
    ]
  },
  {
    key: 'group-2',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'End Date',
        valueKey: 'end_date',
        type: 'date',
        ariaLabel: 'end date',
        min: '2023-01-01T00:00',
        max: '2040-12-31T23:59',
        required: true
      }
    ]
  },
  {
    key: 'group-3',
    className: 'input-group mb-3 ',
    showLabel: false,
    inputs: [
      {
        placeholder: 'Subdomain (optional)',
        valueKey: 'subdomain',
        type: 'text',
        ariaLabel: 'Subdomain'
      },
      {
        placeholder: 'Callback URL (optional)',
        valueKey: 'callback_url',
        type: 'text',
        ariaLabel: 'Callback URL'
      }
    ]
  },
  {
    key: 'group-4',
    className: 'input-group mb-3',
    showLabel: true,
    inputs: [
      {
        label: 'Concurrency Value',
        valueKey: 'concurrency_value',
        type: 'number',
        ariaLabel: 'concurrency value',
        min: 0,
        required: true
      },
      {
        label: 'Total Users',
        valueKey: 'total_users',
        type: 'number',
        ariaLabel: 'Total Users',
        min: 1,
        required: true
      }
    ]
  }
];

export const USER_TYPES = {
  PRO: false,
  LITE: true
};

export const USER_TYPES_ENUM = {
  [USER_TYPES.PRO]: 'Pro',
  [USER_TYPES.LITE]: 'Lite'
};

export const USER_ROLE = {
  TEAM_MEMBER: 2,
  TEAM_ADMIN: 3
};

export const USER_ROLE_ENUM = {
  [USER_ROLE.TEAM_MEMBER]: 'Team Member',
  [USER_ROLE.TEAM_ADMIN]: 'Team Admin'
};

export const COMPANY_STATUS = {
  ACTIVE_PRO: 1,
  FREE_TRIAL: 2,
  FREE_TRIAL_EXPIRED: 3,
  PILOT_ENTERPRISE: 4,
  PILOT_EXPIRED: 5,
  PRO_EXPIRED: 6,
  ACTIVE_ENTERPRISE: 7,
  EXPIRED_ENTERPRISE: 8
};

export const COMPANY_TYPE_NAME = {
  [COMPANY_STATUS.ACTIVE_PRO]: 'Active Pro',
  [COMPANY_STATUS.FREE_TRIAL]: 'Free Trial',
  [COMPANY_STATUS.FREE_TRIAL_EXPIRED]: 'Free Trial Expired',
  [COMPANY_STATUS.PILOT_ENTERPRISE]: 'Pilot Enterprise',
  [COMPANY_STATUS.PILOT_EXPIRED]: 'Pilot Expired',
  [COMPANY_STATUS.PRO_EXPIRED]: 'Pro Expired',
  [COMPANY_STATUS.ACTIVE_ENTERPRISE]: 'Active Enterprise',
  [COMPANY_STATUS.EXPIRED_ENTERPRISE]: 'Expired Enterprise'
};

export const RECORDS_PER_PAGE = 50;

export const BILLING_FREQUENCY_ENUM = {
  QUATERLY: 4,
  MONTHLY: 12,
  HALF_YEARLY: 2,
  ANNUAL: 1
};

export const BILLING_FREQUENCY = {
  [BILLING_FREQUENCY_ENUM.QUATERLY]: 'Quaterly',
  [BILLING_FREQUENCY_ENUM.HALF_YEARLY]: 'Half Yearly',
  [BILLING_FREQUENCY_ENUM.MONTHLY]: 'Monthly',
  [BILLING_FREQUENCY_ENUM.ANNUAL]: 'Annual'
};

export const INITIAL_FORM_DATA = {
  email: '',
  end_date: '',
  reports_given: [],
  default_report: '',
  ignore_marketing_mailer: true,
  ignore_draft_limit: true,
  ignore_size_limit: true,
  max_size_limit: 0,
  restrict_report_switching: true,
  restrict_custom_report_creation: true,
  ignore_concurrency_limit: false,
  show_optional_feature: false,
  concurrency_value: 2,
  min_measurement_size_unit: 0,
  apply_role_level_restriction: false,
  subdomain: '',
  callback_url: '',
  concurrency_value_construction: 0,
  account_segment: ACCOUNT_SEGMENT_ENUM.MID_MARKET,
  company_vertical: COMPANY_VERTICAL_ENUM.ACE,
  key_account_manager: '',
  onboarding_specialist: ''
};

export const FIELDS_TO_REMOVE_FOR_BEAM_USER = [
  'show_optional_feature',
  'restrict_custom_report_creation',
  'restrict_report_switching',
  'ignore_size_limit',
  'max_size_limit',
  'reports_given',
  'concurrency_value_construction',
  'min_measurement_size_unit',
  'default_report'
];

export const CONTRACT_INFO_FIELDS = {
  email: '',
  billing_email: '',
  company_name: '',
  address: '',
  city: '',
  zip: '',
  country: COUNTRY_CODE.USA,
  start_date: '',
  end_date: '',
  billing_frequency: BILLING_FREQUENCY_ENUM.QUATERLY,
  aerial_contract_amount: '',
  per_acre_cost: '',
  remeasurement_contract_amount: '',
  remeasurement_per_acre_cost: '',
  bpt_contract_amount: '',
  workable_sheet_cost: '',
  addendum_sheet_cost: '',
  manual_worksheet_cost: '',
  manual_per_acre_cost: '',
  manual_threshold_acres: '',
  trade_wise_pricing: { others: { [CATEGORY_PRICING_TYPES.FRESH]: 0, [CATEGORY_PRICING_TYPES.ADDENDUM]: 0 } }
};

// Copy Transfer

export const REQUEST_TYPE_ENUM = {
  AERIAL: 1,
  CONSTRUCTION: 2
};

export const REQUEST_TYPE = {
  [REQUEST_TYPE_ENUM.AERIAL]: 'Aerial',
  [REQUEST_TYPE_ENUM.CONSTRUCTION]: 'Construction'
};

export const BPT_TANSFER_TYPE_ENUM = {
  NOT_COPY_AND_CHARGE: 1,
  COPY_AND_NOT_CHARGE: 2,
  NOT_COPY_AND_NOT_CHARGE: 3
};

export const AERIAL_TANSFER_TYPE_ENUM = {
  NOT_COPY_AND_CHARGE: 1,
  COPY_AND_NOT_CHARGE: 2,
  NOT_COPY_AND_NOT_CHARGE: 3
};

export const TRANSFER_TYPE_ENUM = {
  PORTFOLIO_TRANSFER: 1,
  NON_PORTFOLIO: 2
};

export const TRANSFER_TYPE = {
  [TRANSFER_TYPE_ENUM.PORTFOLIO_TRANSFER]: 'Portfolio takeoff transfer',
  [TRANSFER_TYPE_ENUM.NON_PORTFOLIO]: 'Non portfolio takeoff transfer'
};

export const GEOMETRY_TYPES = [
  {
    label: 'POINT',
    value: 1
  },
  {
    label: 'LINE',
    value: 2
  },
  {
    label: 'POLYGON',
    value: 3
  }
];

export const GROUP_TYPE = [
  {
    label: 'NONE',
    value: 1
  },
  {
    label: 'SOFTSCAPE',
    value: 2
  },
  {
    label: 'HARDSCAPE',
    value: 3
  },
  {
    label: 'EDGE',
    value: 4
  },
  {
    label: 'PAVING',
    value: 5
  }
];

export const BPT_TAB_ENUM = {
  VALIDATE_REQUEST: 0
};

export const OPERATIONS_TAB_ENUM = {
  GENERATE_DELIVERY_SHEET: 0,
  CREATE_FEATURE: 1,
  PORTFOLIOS: 2
};
export const COMPANIES_TAB_ENUM = {
  COMPANY_DETAILS: 0,
  COMPANY_USAGE: 1
};

export const EXPORT_TYPE_ENUM = {
  FOLDER: 1,
  REQUESTS: 2,
  ORCHESTRATOR: 3
};
export const COMPANY_TYPE_ENUM = {
  ENTERPRISE: 1,
  NON_ENTERPRISE: 2
};

export const STATUS_ENUM = {
  ESTIMATION: 1,
  WAITING_FOR_CLIENT: 2,
  TO_DO: 3,
  IN_PROGRESS: 4,
  COMPLETED: 5,
  CANCELLED_BY_CLIENT: 6
};

export const STATUS = {
  [STATUS_ENUM.WAITING_FOR_CLIENT]: 'Waiting for client',
  [STATUS_ENUM.CANCELLED_BY_CLIENT]: 'Cancelled by client',
  [STATUS_ENUM.ESTIMATION]: 'Estimation',
  [STATUS_ENUM.TO_DO]: 'To do',
  [STATUS_ENUM.IN_PROGRESS]: 'In progress',
  [STATUS_ENUM.COMPLETED]: 'Completed'
};

export const PORTFOLIO_REVIEW_ENUM = {
  FALCON: 1,
  FLOCK: 2
};

export const SCOPE_TYPE_ENUM = {
  BASIC: 'included',
  ADVANCED: 'additional'
};

export const ROSETTA_TAB_ENUM = {
  SCOPE_SELECTION: 0,
  QUOTE_PRICING: 1
};

export const PAYMENT_TERMS_ENUM = {
  QUARTERLY: 1,
  SEMI_ANNUAL: 2,
  HIDDEN: 3
};

export const PAYMENT_TERMS_LABELS = {
  [PAYMENT_TERMS_ENUM.QUARTERLY]: 'Quarterly',
  [PAYMENT_TERMS_ENUM.SEMI_ANNUAL]: 'Semi-Annual',
  [PAYMENT_TERMS_ENUM.HIDDEN]: 'Hidden (Annual Only)'
};

export const LABEL_CONSTANTS = {
  [COMPANY_STATUS.FREE_TRIAL]: '',
  [COMPANY_STATUS.FREE_TRIAL_EXPIRED]: '',
  [COMPANY_STATUS.ACTIVE_PRO]: 'Plan',
  [COMPANY_STATUS.PILOT_ENTERPRISE]: 'Platform Access',
  [COMPANY_STATUS.PILOT_EXPIRED]: 'Platform Access',
  [COMPANY_STATUS.PRO_EXPIRED]: 'Plan',
  [COMPANY_STATUS.ACTIVE_ENTERPRISE]: 'Platform Access',
  [COMPANY_STATUS.EXPIRED_ENTERPRISE]: 'Platform Access'
};

export const COMPANY_STATUS_NEW_ENUM = {
  ACTIVE_PRO: 1,
  FREE_TRIAL: 2,
  FREE_TRIAL_EXPIRED: 3,
  PILOT_ENTERPRISE: 4,
  PILOT_EXPIRED: 5,
  PRO_EXPIRED: 6,
  ACTIVE_ENTERPRISE: 7,
  EXPIRED_ENTERPRISE: 8
};

export const COMPANY_STATUS_NEW = {
  [COMPANY_STATUS_NEW_ENUM.ACTIVE_PRO]: 'Active Pro',
  [COMPANY_STATUS_NEW_ENUM.FREE_TRIAL]: 'Free Trial',
  [COMPANY_STATUS_NEW_ENUM.FREE_TRIAL_EXPIRED]: 'Free Trial Expired',
  [COMPANY_STATUS_NEW_ENUM.PILOT_ENTERPRISE]: 'Pilot Enterprise',
  [COMPANY_STATUS_NEW_ENUM.PILOT_EXPIRED]: 'Pilot Expired',
  [COMPANY_STATUS_NEW_ENUM.PRO_EXPIRED]: 'Pro Expired',
  [COMPANY_STATUS_NEW_ENUM.ACTIVE_ENTERPRISE]: 'Active Enterprise',
  [COMPANY_STATUS_NEW_ENUM.EXPIRED_ENTERPRISE]: 'Expired Enterprise'
};

export const SERVICE_TYPE = {
  1: 'FIELD SERVICE',
  2: 'GC'
};

export const COMPANY_TYPE = {
  [COMPANY_TYPE_ENUM.ENTERPRISE]: 'Enterprise',
  [COMPANY_TYPE_ENUM.NON_ENTERPRISE]: 'Non-Enterprise'
};

export const BEAM_USER = 'ibeam';

export const EMPTY_ARRAY = [];

export const DISCOUNT_TYPE = {
  1: 'Percentage',
  2: 'Flat'
};

export const CURRENCY_DROPDOWN = [
  {
    id: 1,
    label: 'USD',
    value: 1
  },
  {
    id: 2,
    label: 'INR',
    value: 2
  }
];

export const DISCOUNT_TYPE_DROPDOWN = [
  { label: 'Percentage', value: 1 },
  { label: 'Flat', value: 2 }
];

export const DISCOUNT_TYPE_ENUM = {
  PERCENTAGE: 1,
  FLAT: 2
};

export const BULK_TAKEOFF_STATUS_ENUM = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3
};

export const BULK_TAKEOFF_ENTERPRISE_STATUS = {
  [BULK_TAKEOFF_STATUS_ENUM.PENDING]: 'Pending',
  [BULK_TAKEOFF_STATUS_ENUM.APPROVED]: 'Approved',
  [BULK_TAKEOFF_STATUS_ENUM.REJECTED]: 'Rejected'
};

export const BULK_TAKEOFF_COLOR = {
  [BULK_TAKEOFF_STATUS_ENUM.PENDING]: '#FFC107',
  [BULK_TAKEOFF_STATUS_ENUM.APPROVED]: '#4CBB7F',
  [BULK_TAKEOFF_STATUS_ENUM.REJECTED]: '#FF7474'
};

export const REQUEST_STATUS_ENUM = {
  ON_HOLD: 1,
  IN_PROGRESS: 2
};

// Beam Module Management
export const MODULE_ACTION_ENUM = {
  FREE_TRIAL: 1,
  ENABLE: 2,
  DISABLE: 3
};

export const MODULE_ACTION_ENUM_LABELS = {
  [MODULE_ACTION_ENUM.FREE_TRIAL]: 'Free Trial',
  [MODULE_ACTION_ENUM.ENABLE]: 'Enable',
  [MODULE_ACTION_ENUM.DISABLE]: 'Disable'
};

export const BEAM_MODULES = [
  { key: 'bid_board', label: 'Bid Board' },
  { key: 'bid_sniper', label: 'Bid Sniper' },
  { key: 'beam_gpt', label: 'Beam GPT' },
  { key: 'bid_track', label: 'Bid Pulse' }
];
